import { render, staticRenderFns } from "./copyCreatePage.vue?vue&type=template&id=2f35a128&scoped=true"
import script from "./copyCreatePage.vue?vue&type=script&lang=js"
export * from "./copyCreatePage.vue?vue&type=script&lang=js"
import style0 from "./copyCreatePage.vue?vue&type=style&index=0&id=2f35a128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f35a128",
  null
  
)

export default component.exports